
namespace SorAraBul.PropertyManagement {

    @Serenity.Decorators.registerClass()
    export class TenantDetailPanelDialog extends Serenity.EntityDialog<TenantDetailPanelRow, any> {
        protected getFormKey() { return TenantDetailPanelForm.formKey; }
        protected getIdProperty() { return TenantDetailPanelRow.idProperty; }
        protected getLocalTextPrefix() { return TenantDetailPanelRow.localTextPrefix; }
        protected getNameProperty() { return TenantDetailPanelRow.nameProperty; }
        protected getService() { return TenantDetailPanelService.baseUrl; }
        protected getDeletePermission() { return TenantDetailPanelRow.deletePermission; }
        protected getInsertPermission() { return TenantDetailPanelRow.insertPermission; }
        protected getUpdatePermission() { return TenantDetailPanelRow.updatePermission; }

        protected form = new TenantDetailPanelForm(this.idPrefix);

        constructor() {
            super();
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons.push(Serenity.Extensions.ReportHelper.createToolButton({
                title: 'PDF',
                cssClass: 'export-pdf-button',
                reportKey: 'SorAraBul.TenantDetailPanelReport',
                getParams: () => ({
                    GId: this.get_entityId()
                })
            }));

            buttons.push({
                title: 'Rapor',
                cssClass: 'sors-report-panel-button',
                icon: 'fa fa-file-text-o',
                onClick: () => {
                    const reportUrl = Q.trimToNull(this.entity.SorsLocalReportUrl);
                    if (reportUrl)
                        window.open(reportUrl, '_blank', 'noopener,noreferrer');
                }
            });

            return buttons;
        }

        protected updateInterface() {
            super.updateInterface();

            this.deleteButton.hide();
            this.applyChangesButton.hide();
            this.saveAndCloseButton.hide();
            this.toolbar.findButton('export-pdf-button').toggle(this.isEditMode());
            this.toolbar.findButton('sors-report-panel-button').toggle(this.isEditMode() && !!Q.trimToNull(this.entity.SorsRaporCompleteDate));
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // Dialog başlığını dinamik olarak ayarlama
            this.dialogTitle = "Kiracı Bilgileri";
        }

        protected onSaveSuccess(response) {
            //this.showSaveSuccessMessage(response);
            //window.location.reload();
        }
    }
}
